var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page express"},[_c('div',{staticClass:"list"},_vm._l((_vm.expressData.logisticsTraceDetails),function(item,index){return _c('div',{key:index,staticClass:"item"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(item.timeDesc))]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(item.desc))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }